<template lang="pug">
div
  section.opensite-sec
    .max-container
      .opetitle-wrap
        .arrow-title-img
          img(src='/assets/img/newwebsite/title-arrow-left.png')
        .optitle-box
          .optitle {{ $t('ui.quickSetup') }}
          .optitle-shadow {{ $t('ui.quickSetup') }}
        .arrow-title-img
          img(src='/assets/img/newwebsite/title-arrow-right.png')
      .opensite-step-wrapper
        .stepnumber-wrap
          //- .stepnum.active
          //-   img(src='/assets/img/newwebsite/step-1-icon.png')
          .stepnum.active
            img(src='/assets/img/newwebsite/step-1-icon.png')
          .stepnum.active
            img(src='/assets/img/newwebsite/step-2-icon.png')
        .step-progress-bar.step3
        .step-caption
          //- .scinfo.active {{ $t('message.choosePackage') }}
          .scinfo.active {{ $t('ui.setUpTheme') }}
          .scinfo.active {{ $t('ui.checkOut') }}
      .theme-setting-wrapper(v-if="product.cart != null")
        .theme-set-wrap
          .checkout-wrapper
            .checkout-info-wrap
              .package-box
                .package-type {{ $t('ui.summary') }}
                .ckbcontent
                  .table-responsive
                    table.order-table(width='100%')
                      tr
                        td {{ $t('ui.id') }}
                        td :
                        td {{ cartId }}
                      tr
                        td {{ $t('ui.created_on') }}
                        td :
                        td {{ getDtFormat(product.cart[0].created_on) }}
                      //- tr
                      //-   td {{ $t('ui.packageLimit') }}
                      //-   td :
                      //-   td {{ $t('ui.standardPackage') }}
                      tr
                        td {{ $t('ui.siteName') }}
                        td :
                        td {{ product.cart[0].site_name }}
              //- .package-box
              //-   .package-type {{ $t('ui.standardPackage') }}
              //-   .package-content
              //-     ul.pcklist.fa-ul
              //-       li
              //-         span.fa-li
              //-           i.fas.fa-check-circle
              //-         | {{ $t('message.fastSecureStable') }}
              //-       li
              //-         span.fa-li
              //-           i.fas.fa-check-circle
              //-         | {{ $t('message.realTimeData') }}
              //-       li
              //-         span.fa-li
              //-           i.fas.fa-check-circle
              //-         | {{ $t('message.highLevelTechTeam') }}
              //-       li
              //-         span.fa-li
              //-           i.fas.fa-check-circle
              //-         | {{ $t('message.strategicEmpowerment') }}
              //-       li
              //-         span.fa-li
              //-           i.fas.fa-check-circle
              //-         | {{ $t('message.supportFirst') }}
              //-       li
              //-         span.fa-li
              //-           i.fas.fa-check-circle
              //-         | {{ $t('message.empowermentBusiness') }}
              //-     .pckline
              //-     .pcksum {{ $t('ui.total') }}
              //-     .pcktotal USDT {{ product.cart[0].package_price }}
            .color-theme-pick-container
              .ques-text.mb-3 {{ $t('message.websiteLayoutAndThemeDesign') }}
              .color-theme-preview
                .color-preview-box
                  DisplayLayoutBoxNew(:imageURL="product.cart[0].theme_code + '/' + product.cart[0].theme_color")
              .illus-purpose.mt-3 *{{ $t('message.previewImageForIllustrationOnly') }} {{ $t('message.actualResultMayVary') }}
      .pck-btn-wrap
        button.btn.btn-primary.pcknext-btn(type="buton" @click="backStep" :disabled="loading")
          span.prevarw
            i.fas.fa-arrow-left
          | {{ $t('ui.back') }}
        button.btn.btn-warning.pcknext-btn(type="button" @click="nextStep" :disabled="loading")
          | {{ $t('ui.createOperatorAccount') }}
          span.nextarw
            i.fas.fa-arrow-right
</template>

<script>
import errorTags from "@/errorTags";
import DisplayLayoutBoxNew from '@/components/siteeditor/newwebsite/model/DisplayLayoutBoxNew.vue'
import config from '@/config'

export default {
  components: {
    DisplayLayoutBoxNew
  },
  props: {
    cartId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      product: {}
    }
  },
  computed: {},
  mounted() {
    this.getCartInfo();
  },
  methods: {
    getDtFormat(dt) {
      return this.$moment(dt).format('HH:mm | DD.MM.YYYY');
    },
    reset() {
      this.loading = false
      this.product = {}
    },
    cartPurchased() {
      let url = config.cartPurchasedUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        cart_id: this.cartId,
        remark: null
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.reset();
                var sendData = {
                  cartId: this.cartId,
                  currentStep: 'PAYMENT',
                  setUpOpAcc: true
                }
                this.$store.dispatch("user/setSelectedNewWebsite", sendData);
                this.$emit('goStep', 1, true);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getCartInfo() {
      let url = config.cartInfoUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        cart_id: this.cartId,
        step_name: 'ALL'
      }

      this.loading = true
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.setVal(response.data.ds);

              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    setVal(data) {
      this.product = data;
    },
    goStep: function (step) {
      this.$emit('goStep', step)
    },
    backStep: function () {
      this.$emit('previousStep')
    },
    nextStep: function () {
      this.cartPurchased();
    }
  }
}
</script>